export default {
  connectToDataSource: 'Mit Datenquelle verbinden',
  noDataSourceFound: 'Dieses Asset ist mit keinem unterstützten SCADA-System oder Controller verbunden.',
};
